import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabelPreset } from '~/models/modules/labelPreset';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root'})
export class LabelService extends ApiServiceBase {
  labelAdded: EventEmitter<any> = new EventEmitter();
  labelPrintUpdated: EventEmitter<any> = new EventEmitter();

  constructor(injector: Injector,
              private http: HttpClient) {
                super(injector);
                this.setBase(API_NAMES.common);
              }

  getLabels() {
    return this.http.get(this._url(`/label`));
  }

  getPresetLabel(isAsset: boolean = false, siteId: number = null, labelType: number = null) {
    let url = `/presetLabel/${isAsset}`;
    if (siteId !== null && siteId !== undefined) {
      url += `/${siteId}`;
    }
    if (labelType !== null && labelType !== undefined) {
      url += `?labelType=${labelType}`;
    }
    return this.http.get(this._url(url));
  }
  getSystemPresetLabel(isAsset: boolean = false, labelType: number = null) {
    let url = `/systemPresetLabel/${isAsset}`;
    if (labelType !== null && labelType !== undefined) {
      url += `?labelType=${labelType}`;
    }
    return this.http.get(this._url(url));
  }
  getCustomLabelPresets(isAsset: boolean = false) {
    return this.http.get(this._url(`/customPresetLabel/${isAsset}`));
  }
 
  getCustomPresetLabelsWithReceiveHistorySource() {
    return this.http.get(this._url(`/customPresetLabelsWithReceiveHistorySource`));
  }
  getCustomPresetLabelsWithStockReceiveHistorySource() {
    return this.http.get(this._url(`/customPresetLabelsWithStockReceiveHistorySource`));
  }
  getCustomPresetLabelsAndLabelSizesForPrePrintedLabels(isAsset: boolean = false)
  {
    return this.http.get(this._url(`/customPresetLabelsAndLabelSizesForPrePrintedLabels/${isAsset}`));
  }
  getLabelSizes() {
    return this.http.get(this._url(`/labelSize`));
  }
  getPresetLabelById(id: number, isAsset: boolean = false): Observable<any>
  {
    if (!id || id.toString() === 'undefined' || id.toString() === 'null') {
      return of(null);
    }
    return this.http.get<any>(this._url(`/${id}/${isAsset}`));
  }
  addLabelPreset(labelPreset: LabelPreset){
    return this.http.post(this._url(`/labelPreset`), labelPreset);
  }
  updateLabelPreset(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }
  copyLabelPreset(labelPreset: LabelPreset) {
    return this.http.post(this._url(`/CopyLabelPreset`), labelPreset);
  }
  deactivateLabelPreset(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
}

  updatePrintPreferences(id: number, model: any) {
    return this.client.put(this._url(`/UpdatePrintPrefrences/${id}`), model);
  }

  getPagesByPrintPreferences(entityState:any)
  {
    return this.http.get(this._url(`/GetPagesByPrintPreferences/${entityState}`));
  }
  getLabelPresetById(id: number): Observable<any>
  {
    if (!id || id.toString() === 'undefined' || id.toString() === 'null') {
      return of(null);
    }
    return this.http.get(this._url(`/GetPresetLabelById/${id}`));
  }

  getLabelSizeById(id: number)
  {
    return this.http.get(this._url(`/GetLabelSizeById/${id}`));
  }
  getPrintPreferenceByPageId(id: number)
  {
    return this.http.get(this._url(`/GetPrintPreferenceById/${id}`));
  }
  getPrintPreferenceByPage(page: string)
  {
    return this.http.get(this._url(`/GetPrintPreferenceByPage/${page}`));
  }

  createPrintPreferences(PrintPreferences:any)
  {
    return this.http.post(this._url(`/CreatePrintPreferences`),PrintPreferences);
  }
  getDefaultDefinition(labelPresetId: number, LabelSizeID: null)
  {
    return this.http.get(this._url(`/GetDefaultDefinition/${labelPresetId}/${LabelSizeID}`));
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Labels${v}`);
  }
}
